
import { updateAppConfig } from '#app'
import { defuFn } from 'C:/BuildAgent/work/7992c122409a32d2/code/fe-app/node_modules/defu/dist/defu.mjs'

const inlineConfig = {
  "nuxt": {}
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}

import cfg0 from "C:/BuildAgent/work/7992c122409a32d2/code/fe-app/app.config.ts"

export default /* #__PURE__ */ defuFn(cfg0, inlineConfig)
